import React from 'react'
import { Alert, Box, Chip, Typography } from '@mui/material'
import type { HealthArea, HealthStatus } from '../../../types/healthCheck'

interface AttentionBannerProps {
  areas: HealthArea[]
  overallVerdict: HealthStatus
}

export const AttentionBanner: React.FC<AttentionBannerProps> = ({
  areas,
  overallVerdict,
}) => {
  if (areas.length === 0) return null

  const severity: 'error' | 'warning' =
    overallVerdict === 'critical' || overallVerdict === 'poor' ? 'error' : 'warning'

  return (
    <Alert severity={severity} sx={{ mb: 4, alignItems: 'center', py: 1.5 }}>
      <Typography variant="body2" sx={{ fontWeight: 600, mb: 0.75 }}>
        {areas.length} area{areas.length > 1 ? 's' : ''} need
        {areas.length === 1 ? 's' : ''} attention
      </Typography>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.75 }}>
        {areas.map((a) => (
          <Chip
            key={a.key}
            label={a.name}
            size="small"
            variant="outlined"
            sx={{
              height: 22,
              fontSize: '0.75rem',
              bgcolor: 'background.paper',
              borderColor: severity === 'error' ? 'error.light' : 'warning.light',
              color: severity === 'error' ? 'error.dark' : 'warning.dark',
            }}
          />
        ))}
      </Box>
    </Alert>
  )
}

export default AttentionBanner
